import PageInitializer from './libs/page-initializer';
import { ArticleContent } from './components/parts/article-content';
import { EVENT_READY } from './constants/event';

PageInitializer.getInstance()
  .ready()
  .then(() => {
    console.log('[Article] Initializing article page...');

    // Initialize Article Content
    const articleContents = document.querySelectorAll<HTMLElement>('.js-article-content');
    console.log('[Article] Found', articleContents.length, 'article contents');

    articleContents.forEach((element) => {
      new ArticleContent(element);
    });

    document.dispatchEvent(new Event(EVENT_READY));
  });
